export const selectUnlockKioskModeActionLoading = state => state.getIn(['kioskMode', 'isLoading']);

export const selectUnlockKioskModeActionResult = state => state.getIn(['kioskMode', 'result']);

export const selectUnlockKioskModeActionError = state => state.getIn(['kioskMode', 'error']);
